// Компаньоны в попапе корзины: матчинг по ПОСЛЕДНЕМУ добавленному товару (items[0] в /cart.js).
// Пул карточек рендерит сервер в <template data-or-cc-pool> (halo-cart-sidebar.liquid),
// здесь только матчинг по тегам (/products/{handle}.js) и клонирование топ-4 в список.
// Фолбек: пустая корзина или ошибка — показываем прежний блок See More.
(function () {
    'use strict';

    if (window.orCartCompanionsInit) return;
    window.orCartCompanionsInit = true;

    var LIMIT = 4;
    var productCache = {};
    var lastKey = '';

    function norm(s) {
        s = s.toLowerCase().trim();
        return s.slice(-1) === 's' ? s.slice(0, -1) : s;
    }

    function getProduct(handle) {
        if (productCache[handle]) return Promise.resolve(productCache[handle]);
        return fetch('/products/' + handle + '.js')
            .then(function (r) { if (!r.ok) throw new Error('product fetch ' + r.status); return r.json(); })
            .then(function (p) { productCache[handle] = p; return p; });
    }

    function update() {
        var box = document.querySelector('[data-or-cc-companions]');
        var seeMore = document.querySelector('[data-or-cc-seemore]');
        var pool = document.querySelector('template[data-or-cc-pool]');
        if (!box || !pool) return;

        function fallback() {
            box.hidden = true;
            if (seeMore) seeMore.hidden = false;
            lastKey = '';
        }

        fetch('/cart.js')
            .then(function (r) { if (!r.ok) throw new Error('cart fetch'); return r.json(); })
            .then(function (cart) {
                if (!cart.items.length) { fallback(); return; }

                var handle = cart.items[0].handle;
                var cartHandles = {};
                cart.items.forEach(function (i) { cartHandles[i.handle] = 1; });
                var key = handle + '|' + Object.keys(cartHandles).sort().join(',');
                if (key === lastKey) return; // состав не менялся — не перерисовываем

                getProduct(handle).then(function (p) {
                    var tags = {};
                    (p.tags || []).forEach(function (t) { tags[t.toLowerCase().trim()] = 1; });

                    var scored = [];
                    pool.content.querySelectorAll('[data-or-cc]').forEach(function (el) {
                        var h = el.getAttribute('data-handle');
                        if (cartHandles[h]) return; // уже в корзине — не предлагаем повторно

                        var plant = (el.getAttribute('data-plant') || '').toLowerCase().trim();
                        if (plant && tags[plant]) return; // своё растение уже в составе товара

                        var seen = {};
                        var matched = [];
                        (el.getAttribute('data-for') || '').split('|').forEach(function (f) {
                            if (!f) return;
                            var fl = f.toLowerCase().trim();
                            if (!tags[fl]) return;
                            var n = norm(fl); // дедуп Carrot/Carrots
                            if (!seen[n]) { seen[n] = 1; matched.push(f); }
                        });

                        var fert = el.hasAttribute('data-fert');
                        var score = matched.length + (fert ? 1000 : 0); // удобрения всегда первые
                        if (score > 0) scored.push({ el: el, score: score, matched: matched, fert: fert });
                    });

                    if (!scored.length) { fallback(); return; }
                    scored.sort(function (a, b) { return b.score - a.score; });

                    var list = box.querySelector('.or-cart-companions__list');
                    list.innerHTML = '';
                    scored.slice(0, LIMIT).forEach(function (c) {
                        var node = document.importNode(c.el, true);
                        var forEl = node.querySelector('[data-or-cc-for]');
                        if (forEl) {
                            forEl.textContent = c.fert
                                ? ' • FOR ALL PLANTS'
                                : (c.matched[0] ? ' • FOR ' + c.matched[0].toUpperCase() : '');
                        }
                        list.appendChild(node);
                    });

                    box.hidden = false;
                    if (seeMore) seeMore.hidden = true;
                    lastKey = key;
                }).catch(fallback);
            })
            .catch(function () { /* /cart.js недоступен — оставляем как есть */ });
    }

    document.addEventListener('cart:updated', update);

    function init() {
        var popup = document.querySelector('.or-view-cart-popup');
        if (!popup) return;
        // Любой сценарий открытия попапа добавляет .active — ловим наблюдателем,
        // чтобы не зависеть от того, кто именно его открыл
        new MutationObserver(function () {
            if (popup.classList.contains('active')) update();
        }).observe(popup, { attributes: true, attributeFilter: ['class'] });
        if (popup.classList.contains('active')) update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
